"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDeviceDetect = require("react-device-detect");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _formik = require("formik");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _schema = require("./schema");

var _LoginResetPin = _interopRequireDefault(require("./LoginResetPin"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var StyledAppIcon = _styledComponents.default.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: block;\n  width: 120px;\n  height: 120px;\n  margin: 2rem auto;\n"])));

var LoginDpg = function LoginDpg(_ref) {
  var onError = _ref.onError,
      onLoginSuccess = _ref.onLoginSuccess,
      dpgUserId = _ref.dpgUserId,
      appIconUrl = _ref.appIconUrl,
      geoLocationCity = _ref.geoLocationCity,
      translations = _ref.translations;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      serverError = _useState2[0],
      setError = _useState2[1];

  var validate = function validate(values) {
    var errors = {};

    if (!/^[0-9]*$/.test(values.pin)) {
      errors.pin = translations.pinValidation;
    }

    return errors;
  };

  var onSubmit = function onSubmit(values, _ref2) {
    var setSubmitting = _ref2.setSubmitting;
    localStorage.removeItem("fiver_react_access_token");
    delete _axios.default.defaults.headers.common["Authorization"];

    _axios.default.post("/auth/dpg-login", {
      dpgUserId: dpgUserId,
      pin: +values.pin
    }).then(function (_ref3) {
      var data = _ref3.data;
      _axios.default.defaults.headers.common["Authorization"] = "Bearer ".concat(data.access_token);

      _axios.default.get("/me").then(function (profileRes) {
        var profile = profileRes.data.data;
        var currentDate = new Date().toLocaleString();
        var dateArray = profile.birthDate.split("-");
        window.xtremepush("set", "user_id", profile.id);
        window.xtremepush("user", "update", {
          user_id: profile.id,
          email: profile.email,
          mobile_number: profile.mobileNumber,
          first_name: profile.firstName,
          last_name: profile.lastName,
          birth_date: profile.birthDate,
          tenant_id: process.env.REACT_APP_TENANT,
          username: profile.username,
          sms_subscription: profile.contactPermissions.smsNotificationsAccepted,
          email_subscription: profile.contactPermissions.emailNotificationsAccepted,
          push_subscription: profile.contactPermissions.inAppNotificationsAccepted
        });

        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.appInterface) {
          window.webkit.messageHandlers.appInterface.postMessage(JSON.stringify({
            profileId: profile.id
          }));
        }

        if (window.appInterface) {
          window.appInterface.postMessage(JSON.stringify({
            profileId: profile.id
          }));
        }

        var lotameData = {
          tenant: [process.env.REACT_APP_TENANT],
          login_date_time: [currentDate],
          login: [profile.username],
          low6_id: ["".concat(profile.id)],
          location: ["".concat(geoLocationCity || "")],
          geolocation_city: ["".concat(geoLocationCity || "")],
          age: ["".concat(Math.floor((new Date() - new Date(dateArray[0], dateArray[1] - 1, dateArray[2])) / (1000 * 60 * 60 * 24 * 365)))],
          operating_system: ["".concat(_reactDeviceDetect.osName, " ").concat(_reactDeviceDetect.osVersion)],
          browser: ["".concat(_reactDeviceDetect.browserName, " ").concat(_reactDeviceDetect.browserVersion)]
        };
        window["lotame_".concat(process.env.REACT_APP_LOTAME_CLIENT_ID)].cmd.push(function () {
          window["lotame_".concat(process.env.REACT_APP_LOTAME_CLIENT_ID)].page({
            behaviorIds: [+process.env.REACT_APP_BEHAVIOUR_LOGIN_ID],
            ruleBuilder: lotameData
          });
        });
        setSubmitting(false);
        onLoginSuccess({
          accessToken: data.access_token
        });
      }).catch(function (_ref4) {
        var response = _ref4.response;
        onError(response, true);
        setSubmitting(false);
        setError(translations.invalidPin);
      });
    }).catch(function (_ref5) {
      var response = _ref5.response;
      onError(response, true);
      setSubmitting(false);
      setError(translations.invalidPin);
    });
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Card, null, /*#__PURE__*/_react.default.createElement(StyledAppIcon, {
    src: appIconUrl
  }), /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: {
      pin: ""
    },
    validate: validate,
    validationSchema: (0, _schema.Schema)(translations),
    onSubmit: onSubmit
  }, function (_ref6) {
    var isValid = _ref6.isValid,
        values = _ref6.values,
        errors = _ref6.errors,
        touched = _ref6.touched,
        dirty = _ref6.dirty,
        handleChange = _ref6.handleChange,
        handleBlur = _ref6.handleBlur,
        isSubmitting = _ref6.isSubmitting;
    return /*#__PURE__*/_react.default.createElement(_formik.Form, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
      type: "password",
      name: "pin",
      pattern: "[0-9]*",
      inputMode: "numeric",
      isError: errors.pin,
      placeholder: translations.enterYourPin,
      onChange: handleChange,
      onBlur: handleBlur,
      value: values.pin
    })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
      isVisible: !isValid && dirty || serverError
    }, serverError && /*#__PURE__*/_react.default.createElement("div", null, serverError), errors.pin && /*#__PURE__*/_react.default.createElement("div", null, errors.pin)), /*#__PURE__*/_react.default.createElement(_LoginResetPin.default, {
      translations: translations,
      onError: onError,
      dpgUserId: dpgUserId
    }), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
      style: {
        marginBottom: "1rem"
      },
      type: "submit",
      disabled: !dirty || isSubmitting || !isValid,
      isLoading: isSubmitting
    }, translations.submit), process.env.NODE_ENV === "development" || process.env.REACT_APP_IS_TOTO_TEST ? /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
      isDefault: true,
      type: "button",
      to: "/"
    }, translations.back) : null);
  })));
};

LoginDpg.defaultProps = {
  isBackgroundDark: false
};
LoginDpg.propTypes = {
  isBackgroundDark: _propTypes.default.bool
};
var _default = LoginDpg;
exports.default = _default;